@if (isImpersonationEnabled) {
	<div class="impersonation-navbar" role="alert">
		<div class="col d-flex">
			<div class="col-6 d-flex user-impersonation text-bold">
				User Impersonation
			</div>
			<div
				class="col-6 d-flex justify-content-start text-bold"
				id="impersonate-name-id"
			>
				Logged in as {{ loggedInUser?.display }} ({{
					loggedInUser?.value?.employeeId
				}})
			</div>
		</div>
	</div>
}
